var React = require('react');
var ReactNative = require('react-native');
var Globals = require('./Globals');
var {
  View,
  StyleSheet,
} = ReactNative;

var ReUpTabBar = require('./ReUpTabBar');

var RewardsCampaigns = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      visibleFeature : null
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor",.6);
    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");

    var rewardsFeature = appManager.getFeatureForName("Rewards");
    var earnPointsFeature = appManager.getFeatureForName("EarnPoints")
    var shouldShowEarnPointsFirst = typeof this.props.extras !== 'undefined' && typeof this.props.extras.showEarnPointsFirst !== 'undefined' && this.props.extras.showEarnPointsFirst;

    return (
      <View style={{flex:1, backgroundColor:generalColor, alignSelf:'stretch', flexDirection:'column'}}>
        <View style={{flex:1, overflow:'hidden', marginTop:Globals.TAB_BAR_HEIGHT}}>
        {this.state.visibleFeature}
        </View>
          <View style={{flexDirection:'column', position:'absolute', top:this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left:0, right:0}}>
          <ReUpTabBar
            style={{flex:1, alignSelf:'stretch'}}
            textColor={generalTitleColor}
            barColor={iconColor}
            rippleColor={rippleColor}
            iconColor={iconColor}
            layout={this.state.layout}
            canDismiss={false}
            initialTabSelected={shouldShowEarnPointsFirst ? 1 : 0}
            showFeature={(feature)=>
            {
              var layout = {width:thisThing.state.layout.width, height:thisThing.state.layout.height-40 - ((this.props.extras && this.props.extras.shouldHideActionBar) ? 0 : Globals.ACTION_BAR_HEIGHT)}
              var featureView = appActions.featureForData(feature, layout, appManager, thisThing.props.extras);
              thisThing.setState({visibleFeature:featureView})
            }}
            hideFeature={()=>
            {

            }}
            buttonFeatures={[rewardsFeature, earnPointsFeature]}
            />
        </View>
      </View>
    );
  }
});

RewardsCampaigns.dataDependencies = [];

module.exports = RewardsCampaigns;
